import Box from "@mui/material/Box";
import LinearProgress from "@mui/material/LinearProgress";

/**
 * Vendored verbatim (structurally) from Mantis Free's `components/Loader.jsx` (MIT — fetched
 * 2026-08, docs/337-ADMIN-MANTIS-MIGRATION.md): a thin, fixed top-of-viewport progress bar used
 * as the auth-restore/page-loading indicator (mirrors the original's role as the app's route-level
 * Suspense fallback).
 */
export function Loader() {
  return (
    <Box sx={{ position: "fixed", top: 0, left: 0, zIndex: 2001, width: 1 }}>
      <LinearProgress color="primary" />
    </Box>
  );
}
